import { Button } from "@/components/ui/button";
import { Settings2 } from "lucide-react";
import { PaymentMethod } from "@/hooks/payments/usePaymentMethods";
import { cn } from "@/lib/utils";

interface PaymentMethodSelectorProps {
  methods: PaymentMethod[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  onManageClick: () => void;
  isLoading: boolean;
}

export const PaymentMethodSelector = ({
  methods,
  selectedId,
  onSelect,
  onManageClick,
  isLoading,
}: PaymentMethodSelectorProps) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <label className="text-sm font-medium">Método de pago</label>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-7 px-2 text-xs"
          onClick={onManageClick}
        >
          <Settings2 className="h-3.5 w-3.5 mr-1" />
          Gestionar
        </Button>
      </div>
      {isLoading ? (
        <p className="text-xs text-muted-foreground">Cargando métodos...</p>
      ) : methods.length === 0 ? (
        <p className="text-xs text-muted-foreground">
          No hay métodos. Hacé clic en "Gestionar" para agregar uno.
        </p>
      ) : (
        <div className="flex flex-wrap gap-2">
          {methods.map((m) => {
            const selected = selectedId === m.id;
            return (
              <button
                key={m.id}
                type="button"
                onClick={() => onSelect(m.id)}
                className={cn(
                  "px-3 py-1.5 rounded-full text-sm border transition-colors",
                  selected
                    ? "bg-primary text-primary-foreground border-primary"
                    : "bg-background text-foreground border-border hover:bg-muted"
                )}
              >
                {m.name}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
